import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MD5hash, API_Link, validateHeader } from "../commons/Constants";
import { FaEye, FaStickyNote, FaExclamationTriangle } from "react-icons/fa";
import { BiErrorCircle } from "react-icons/bi";
import { GrRotateLeft } from "react-icons/gr";
import { BsFillCircleFill, BsQuestionLg } from "react-icons/bs";
import "./../assets/sass/style.css";
import "./../assets/sass/totalreview.css";
import IncludedFulltext from "../Pages/user/includedfulltext";
import { API_SRC } from "../commons/Constants";
import gif from "./../assets/img/spin.gif";
import userImgAvator from "./../assets/img/user.png";
import NoteComponent from "./noteComponent";
import { useSnackbar } from "notistack";
import { FiFilter } from "react-icons/fi";
import { BsSortAlphaDown } from "react-icons/bs";
import Select from "react-select";
import { Form, Modal, Button, ProgressBar } from "react-bootstrap";
import parse from "html-react-parser";

const ExcludedFulltextComponent = () => {
  const MD5hash = validateHeader();
  const [arrayData, setArrayData] = useState([]);
  const [isFeatchingArticles, setIsFeatchingArticles] = useState();
  const [isError, setIsError] = useState(false);
  const [progress, setProgress] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));
  const studyId = localStorage.getItem("studyId");
  const [show, setShow] = useState(false);
  const token = user?.token;

  const { enqueueSnackbar } = useSnackbar();
  const [notes, setNotes] = useState({});
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [savedNotes, setSavedNotes] = useState({});
  const dropdownRef = useRef(null);
  function capitalizeWords(str) {
    if (!str || typeof str !== "string") {
      return "Unknown Author"; // or any default text you'd like to show
    }

    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  const formatOvidTags = (text) => {
    if (!text) return "";

    const formattedText = text
      .replace(/<ovid:b>(.*?)<\/ovid:b>/g, "<br><b>$1</b>")
      .replace(/<ovid:i>(.*?)<\/ovid:i>/g, "<i>$1</i>")
      .replace(/<ovid:sub>(.*?)<\/ovid:sub>/g, "<sub>$1</sub>")
      .replace(/<ovid:sup>(.*?)<\/ovid:sup>/g, "<sup>$1</sup>")
      .replace(/<ovid:u>(.*?)<\/ovid:u>/g, "<u>$1</u>")
      .replace(/<ovid:br\/>/g, "<br>")
      .replace(
        /<ovid:link href="(.*?)">(.*?)<\/ovid:link>/g,
        "<a href='$1'>$2</a>"
      )
      .replace(/<ovid:hl>(.*?)<\/ovid:hl>/g, "<mark>$1</mark>")
      .replace(/<ovid:para>(.*?)<\/ovid:para>/g, "<p>$1</p>")
      .replace(/<ovid:strike>(.*?)<\/ovid:strike>/g, "<s>$1</s>");
    return formattedText.replace(
      /^(<.*?>)*(\w)/,
      (match, tags, firstLetter) => `${tags || ""}${firstLetter.toUpperCase()}`
    );
  };
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFilter, setShowFilter] = useState(false); // Add showFilter state
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentOptions, setCurrentOptions] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [normalizedValues, setNormalizedValues] = useState([]); // State for normalized values
  const [isFetchingArticlesAPICalled, setIsFetchingArticlesAPICalled] =
    useState(false);

  useEffect(() => {
    const filtered = arrayData.filter(filterArticles(selectedOptions));
    setFilteredArticles(filtered);
  }, [arrayData]);
  const toggleFilterModal = () => {
    const filtered = arrayData.filter(filterArticles(selectedOptions));
    setFilteredArticles(filtered);
    setShowFilterModal(!showFilterModal);
  };
  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const [selectedFilters, setSelectedFilters] = useState([]);
  const selectOptions = currentOptions.map((option) => ({
    value: option,
    label: option,
  }));
  const toggleCloseModal = () => {
    setSelectedOptions([]);
    setCurrentOptions([]);
    setNormalizedValues([]);
    setFilterType("");
    setFilteredArticles(arrayData);
  };
  const toggleHideModal = () => {
    setShowFilterModal(!showFilterModal);
  };
  const year = [...new Set(arrayData?.map((article) => article?.year))];
  const authors = [
    ...new Set(
      arrayData?.map((article) => article?.authors?.split(",")[0]?.trim())
    ),
  ];
  const journals = [...new Set(arrayData?.map((article) => article?.journal))];

  // Sort articles based on selected field
  const sortArticles = (field) => {
    const sorted = [...filteredArticles].sort((a, b) => {
      const valueA = a[field] ? a[field].toString().toLowerCase() : "";
      const valueB = b[field] ? b[field].toString().toLowerCase() : "";
      return valueA.localeCompare(valueB);
    });
    setFilteredArticles(sorted); // Call the parent callback with sorted array
    setShowDropdown(false); // Hide dropdown after selection
  };
  const handleFilterChange = (type) => {
    setFilterType(type);

    // Assuming `selectedOptions` is the array of selected options (e.g., selected years, authors, or journals)
    const normalizedValues = selectedOptions.map((value) =>
      typeof value === "object" && value !== null && "value" in value
        ? typeof value.value === "string"
          ? value.value.toLowerCase()
          : String(value.value).toLowerCase()
        : typeof value === "string"
        ? value.toLowerCase()
        : String(value).toLowerCase()
    );

    switch (type) {
      case "year":
        const filteredYears =
          normalizedValues.length === 0
            ? [...new Set(arrayData.map((article) => article.year))] // Show all unique years if no filters are applied
            : arrayData
                .filter((article) =>
                  normalizedValues.some(
                    (value) =>
                      article.authors
                        ?.split(",")
                        ?.map((a) => a.trim().toLowerCase())
                        .includes(value) ||
                      article.journal.toLowerCase().includes(value)
                  )
                )
                .map((article) => article.year)
                .filter((year, index, self) => self.indexOf(year) === index); // Remove duplicates

        // Sort the years in ascending order
        const sortedYears = filteredYears.sort((a, b) => b - a);

        setCurrentOptions(sortedYears);
        break;

      case "author":
        const filteredAuthors =
          normalizedValues.length === 0
            ? authors // Show all authors if no filters are applied
            : authors.filter((author) =>
                arrayData.some(
                  (article) =>
                    article.authors
                      ?.split(",")
                      .map((a) => a.trim().toLowerCase())
                      .includes(author.toLowerCase()) &&
                    normalizedValues.some(
                      (value) =>
                        String(article.year).toLowerCase().includes(value) ||
                        article.journal.toLowerCase().includes(value)
                    )
                )
              );

        // Capitalize first letter of each word in the filtered authors
        const capitalizedAuthors = filteredAuthors.map((author) =>
          capitalizeWords(author)
        );
        setCurrentOptions(capitalizedAuthors);
        break;

      case "journal":
        const filteredJournals =
          normalizedValues.length === 0
            ? journals // Show all journals if no filters are applied
            : journals.filter((journal) =>
                arrayData.some(
                  (article) =>
                    article.journal.toLowerCase() === journal.toLowerCase() &&
                    normalizedValues.some(
                      (value) =>
                        article.authors
                          ?.split(",")
                          .map((a) => a.trim().toLowerCase())
                          .includes(value) ||
                        String(article.year).toLowerCase().includes(value)
                    )
                )
              );

        // Capitalize first letter of each word in the filtered journals
        const capitalizedJournals = filteredJournals.map((journal) =>
          capitalizeWords(journal)
        );
        setCurrentOptions(capitalizedJournals);
        break;

      default:
        setCurrentOptions([]);
        break;
    }
  };

  const handleSelectChange1 = (options) => {
    setSelectedOptions(options || []);
  };
  const filterArticles = (selectedValues) => (article) => {
    // If no filters are selected, include all articles
    if (!selectedValues.length) {
      setNormalizedValues([]);
      return true;
    }

    // Normalize selected values (convert to lowercase)
    const normalizedValues = selectedValues.map((value) =>
      typeof value.value === "string"
        ? value.value.toLowerCase()
        : String(value.value).toLowerCase()
    );

    // Update normalized values in the state
    setNormalizedValues(normalizedValues);

    // Check if all selected values match (AND logic)
    const matchesAllFilters = normalizedValues.every((value) => {
      // Match year
      const yearMatch = String(article?.year)?.toLowerCase().includes(value);

      // Extract the first author
      let firstAuthor;
      if (article?.authors?.includes(",")) {
        firstAuthor = article?.authors?.split(",")[0].trim();
      } else if (article?.authors?.includes(" ")) {
        firstAuthor = article?.authors?.split(" ")[0].trim();
      } else {
        firstAuthor = article?.authors?.trim();
      }
      firstAuthor = firstAuthor?.toLowerCase();
      const authorMatch = firstAuthor?.includes(value);

      // Match journal
      const journalMatch = article?.journal?.toLowerCase().includes(value);

      // Ensure the article matches all filters (year, author, journal)
      return yearMatch || authorMatch || journalMatch;
    });

    // Return true if all selected filters match the article
    return matchesAllFilters;
  };

  const highlightText = (text) => {
    if (!normalizedValues || typeof text !== "string") return text; // Ensure text is a string
    const highlighted = normalizedValues?.find((value) =>
      text?.toLowerCase().includes(value)
    );
    if (!highlighted) return text;

    const parts = text.split(new RegExp(`(${highlighted})`, "gi"));
    return parts?.map((part, index) =>
      part?.toLowerCase() === highlighted ? (
        <span
          key={index}
          style={{ backgroundColor: "yellow", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  const getReviewArticles = async () => {
    setIsFeatchingArticles(true);
    let page = 1;
    const perPage = 25; // Define the number of items per page
    let totalPages = 1; // Initialize with a value to start the loop
    let allResults = [];
    try {
      do {
        var config = {
          method: "get",
          url: `${API_Link}getReviewArticles?review_id=${studyId}&fulltext=Yes&exclusion=Yes`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "misr-auth": MD5hash,
          },
          params: {
            page: page,
            per_page: perPage,
          },
        };

        const response = await axios(config);
        const resData = response?.data;
        // Append new results
        allResults = [...allResults, ...resData?.articles?.data];

        totalPages = resData?.articles?.last_page; // Update totalPages for pagination
        page++;

        // Update progress as pages are fetched
        const progressPercent = Math.min((page / totalPages) * 100, 100);
        setProgress(progressPercent);
        const notesTemp = allResults.reduce((acc, article) => {
          acc[article.id] = article.full_text_note;
          return acc;
        }, {});

        setNotes(notesTemp);
        const notesSaveTemp = allResults.reduce((acc, article) => {
          if (article.full_text_note !== null) {
            acc[article.id] = true;
          }

          return acc;
        }, {});
        setSavedNotes(notesSaveTemp);
        setArrayData(allResults);
      } while (page <= totalPages);

      // Set progress to 100% and hide progress bar after a delay
      setProgress(100);
    } catch (error) {
      console.log(error);

      setIsError(true);
    } finally {
      setIsFeatchingArticles(false);
      setIsFetchingArticlesAPICalled(true);
    }
  };
  useEffect(() => {
    getReviewArticles();
  }, []);

  const [isActive, setIsActive] = useState(null);
  const [isInclude, setIsInclude] = useState(null);
  const [isExclude, setIsExclude] = useState(null);
  const [mayBe, setmayBe] = useState(null);
  //handle increase Decrease Height
  const handleClick = (index) => {
    setIsActive(!isActive);
    if (isActive === index) {
      return setIsActive(null);
    }
    setIsActive(index);
  };
  // handle Include
  const handleInclude = (index) => {
    if (isInclude === index) {
      return setIsInclude(null);
    }
    setIsInclude(index);
  };
  // handle Exclude
  const handleExclude = (index) => {
    if (isExclude === index) {
      return setIsExclude(null);
    }
    setIsExclude(index);
  };
  // handle Exclude
  const handleMayBe = (index) => {
    if (mayBe === index) {
      return setmayBe(null);
    }
    setmayBe(index);
  };
  const [file, setFile] = useState();
  const [source, setSource] = useState();
  const handleOpenModal = (index, id) => {
    arrayData.map((article) => {
      if (article.id === id) {
        setFile(article.file_path);
        setSource(article.source);
      }
    });
    setShow(true);
  };
  const handleCloseModal = (index) => {
    setShow(false);
  };
  // code for capitalize
  const smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|of|is|it|on|or|The|to|vs?\.?|via)$/i;
  function shouldBeUppercase(word, index, length) {
    //always capitalize the first and last words
    if (index == 0 || index == length - 1) return true;

    //only capitalize other words if they don't match the small words pattern
    return !smallWords.test(word.toLowerCase());
  }

  function convertFirstLetterToUpperCase(str) {
    //split into words
    const words = str.split(" ");

    //change the case and rejoin into a string
    return words
      .map((word, index, length) =>
        shouldBeUppercase(word, index, length)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.toLowerCase()
      )
      .join(" ");
  }

  const handleChangeNote = (e, articleId) => {
    const { value } = e.target;
    setNotes((prevNotes) => ({
      ...prevNotes,
      [articleId]: value, // Update note for the specific article
    }));
  };

  const handleSaveNote = async (articleId) => {
    const noteToSave = notes[articleId];
    setIsSavingNote(true);
    const data = {
      article_id: articleId,
      note: noteToSave,
      full_text: "Yes",
    };
    try {
      const config = {
        method: "post",
        url: `${API_Link}addNote`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        data: data,
      };

      const res = await axios(config);
      if (res?.data?.note === null) {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: false,
        }));
      } else {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: true,
        }));
      }
    } catch (error) {
      enqueueSnackbar("An Error Occurs While Saving Note", {
        variant: "error",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } finally {
      setIsSavingNote(false); // This will always run after the try or catch block
    }
  };

  // click outside to remove drop down
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  function capitalizeTextProperly(text) {
    // Capitalize the first letter of the text
    text = text.charAt(0).toUpperCase() + text.slice(1);

    // Capitalize the first word after specified punctuation marks
    return text.replace(/([.?!:;]\s*)([a-z])/g, (match, punct, char) => {
      // Capitalize the character following the punctuation
      return punct + char.toUpperCase();
    });
  }

  return (
    <div className="page--content" onClick={handleClickOutside}>
      <div className="position-sticky position-sticky-top z-index-9">
        <div className="page--section">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="page--heading">Fulltext Excluded</h1>
            </div>
          </div>

          <div className="row mt-3 count-colour d-flex align-items-center justify-content-center">
            <div className="col-lg-6 text-start">
              <div
                style={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  marginLeft: "8px",
                }}
              >
                {/* <button onClick={toggleDropdown} className="sort-filter-btn">
                  Sort <BsSortAlphaDown style={{ fontSize: "20px" }} />
                </button> */}
                {showDropdown && (
                  <div
                    ref={dropdownRef}
                    style={{
                      position: "absolute",
                      top: "30px",
                      left: 0,
                      backgroundColor: "#ffff",
                      boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                      zIndex: 1,
                      padding: "8px",
                    }}
                  >
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("title")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Title
                    </div>
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("journal")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Journal
                    </div>
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("authors")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Authors
                    </div>
                    <div
                      className="sort-list-dropdown"
                      onClick={() => sortArticles("abstract")}
                      style={{ cursor: "pointer", padding: "4px 8px" }}
                    >
                      Abstract
                    </div>
                  </div>
                )}
                {/* <button onClick={toggleFilterModal} className="sort-filter-btn">
                  Filter <FiFilter style={{ fontSize: "20px" }} />
                </button> */}
              </div>
            </div>
            <div className="col-lg-6 text-end">
              <span className="me-3">
                Total Article(s): <strong>{arrayData.length}</strong>
              </span>
            </div>
          </div>
          <Modal show={showFilterModal} onHide={toggleHideModal}>
            <Modal.Header closeButton>
              <Modal.Title>Filter Options</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Form className="d-flex justify-content-around mb-2">
                  <Form.Check
                    type="radio"
                    label="Year"
                    name="filterType"
                    value="title"
                    checked={filterType === "year"}
                    onChange={() => handleFilterChange("year")}
                  />
                  <Form.Check
                    type="radio"
                    label="Author"
                    name="filterType"
                    value="author"
                    checked={filterType === "author"}
                    onChange={() => handleFilterChange("author")}
                  />
                  <Form.Check
                    type="radio"
                    label="Journal"
                    name="filterType"
                    value="journal"
                    checked={filterType === "journal"}
                    onChange={() => handleFilterChange("journal")}
                  />
                </Form>
                <Select
                  options={selectOptions}
                  isMulti
                  value={selectedOptions}
                  onChange={handleSelectChange1}
                  closeMenuOnSelect={false}
                  placeholder="Select filter options..."
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={toggleCloseModal}>
                Reset
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  toggleFilterModal();
                }}
              >
                Apply Filter
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        {isFeatchingArticles && (
          <div className="progressBarData">
            <ProgressBar now={progress} />
          </div>
        )}
      </div>
      <div className="row">
        {filteredArticles &&
          filteredArticles.length > 0 &&
          filteredArticles.map(
            ({ id, title, authors, journal, abstract, year }, index) => (
              <div className="row  z-index-0" key={index}>
                {/* Handle Background Color Change On Include, Exclude  */}
                <div
                  className="inner--box--row"
                  style={{
                    backgroundColor:
                      isInclude === index
                        ? " rgba(0,255,0,0.1)"
                        : isExclude === index
                        ? "rgba(255,0,0,0.1)"
                        : mayBe === index
                        ? " rgba(255,255,0,0.1)"
                        : "",
                  }}
                >
                  <span className="index--numbering fw-bold">{index + 1})</span>
                  <div className="row width-100">
                    <div className="width--80">
                      {/* <label className='form-check-label' htmlFor='flexCheckDefault2'>
                    {Title}
                  </label> */}
                      <h1 className="heading3">
                        {parse(
                          formatOvidTags(convertFirstLetterToUpperCase(title))
                        )}
                      </h1>
                      <div className="d-flex ">
                        <p className="small text-muted authors-font ms-1">
                          <span className="authors-font fw-bold">
                            Author(s):
                          </span>{" "}
                          {highlightText(
                            capitalizeWords(authors.replace(/,/g, ", ")) + ".",
                            normalizedValues
                          )}
                        </p>
                      </div>
                      {/* <h1 className='heading3'>{Journal}</h1> */}

                      {journal ? (
                        <label className="small text-muted journal-font">
                          <span className="fw-bold">Journal: </span>
                          {highlightText(
                            convertFirstLetterToUpperCase(journal) + ".",
                            normalizedValues
                          )}
                        </label>
                      ) : (
                        ""
                      )}
                      <div>
                        {year ? (
                          <label className="small text-muted journal-font">
                            <span className="fw-bold">Year:</span>{" "}
                            {highlightText(year, normalizedValues)}
                          </label>
                        ) : (
                          ""
                        )}{" "}
                      </div>
                      {/* Handle Hight of Paragraph Here */}
                      <p
                        className={
                          isActive === index
                            ? "Increase-height--of--paragraph cursor-pointer"
                            : "Reduce-height--of--paragraph underline-showAbstarct"
                        }
                        onClick={() => handleClick(index)}
                      >
                        {isActive === index
                          ? parse(formatOvidTags(abstract))
                          : "Show Abstract"}
                      </p>
                    </div>
                    <div className="width-20">
                      <div className="">
                        <div className="btn--new--ul">
                          {/* <Link
                            to="#"
                            data-bs-toggle="tooltip"
                            className="link"
                            title="View"
                            onClick={() => handleOpenModal(index, id)}
                          >
                            <FaEye />
                          </Link> */}
                          <Link
                            to="#"
                            data-bs-toggle="tooltip"
                            className="link position-relative"
                            title="Detials"
                            onClick={() => handleClick(index)}
                          >
                            {savedNotes[id] && <span className="dot"></span>}
                            <FaStickyNote />
                          </Link>
                        </div>
                        {isActive === index ? "" : <p></p>}
                      </div>
                    </div>

                    {isActive === index && (
                      <NoteComponent
                        id={id}
                        notes={notes}
                        handleChangeNote={handleChangeNote}
                        handleSaveNote={handleSaveNote}
                        isSavingNote={isSavingNote}
                        savedNotes={savedNotes}
                      />
                    )}
                  </div>
                  {show && (
                    <>
                      <div className="template_modal">
                        <div className="template_modal-wrapper">
                          <div className="modal--header">
                            <div className="text-end">
                              <button
                                className="btn-danger"
                                onClick={() => {
                                  handleCloseModal();
                                }}
                              >
                                {" "}
                                Close{" "}
                              </button>
                            </div>
                          </div>
                          <div className="modal--body">
                            {source && (
                              <iframe
                                width="100%"
                                title="attached file"
                                src={`${source}`}
                              ></iframe>
                            )}

                            {file && (
                              <iframe
                                width="100%"
                                title="attached file"
                                src={`${API_SRC + "/" + file}`}
                              ></iframe>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )
          )}

        {!isFeatchingArticles &&
          arrayData.length === 0 &&
          !isError &&
          isFetchingArticlesAPICalled && (
            <div className="no-data-found-main">
              <h4 className="no-data-found text-muted m-auto opacity-50">
                <FaExclamationTriangle size={50} color="orange" />
                <span className="ms-3">There are no excluded fulltext.</span>
              </h4>
            </div>
          )}
        {isError && !isFeatchingArticles && isFetchingArticlesAPICalled && (
          <div className="no-data-found-main">
            <h4 className="no-data-found text-muted m-auto opacity-50">
              <BiErrorCircle size={50} color="orange" />
              <span className="ms-3">Some thing went wrong.</span>
            </h4>
          </div>
        )}
        {isFeatchingArticles && (
          <div
            className={
              arrayData.length >= 25 ? "loading-second-time" : "preload"
            }
          >
            <img src={gif} alt="Loading..." />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExcludedFulltextComponent;
